export default __webpack_public_path__ + "static/media/horizon_logo.13fc4a2a.png";